export const PREFERENCES = {
    music: 'CAT_muziek',
    culture: 'CAT_cultuur',
    family: 'CAT_familie',
    spectacles: 'CAT_spektakel',
    sports: 'CAT_sport',
    beatAlert: 'NB_beat_tips',
    sportpaleis: 'NB_sportpaleis',
    'afas-dome': 'NB_afas_dome',
    'lotto-arena': 'NB_lottoarena',
    'forest-national': 'NB_vorstnationaal',
    'trixxo-arena': 'NB_trixxoarena',
    'stadsschouwburg-antwerp': 'NB_stadsschouwburgantwerpen',
    'capitole-ghent': 'NB_capitolegent',
    'trixxo-theater': 'NB_trixxotheater',
    VIP: 'NB_vip',
    group: 'NB_groepen',
    tips: 'NB_beat_tips',
    crew: 'NB_crew',
    birthdate: 'NB_happy_birthday',
    whatsapp: 'MOB_WhatsApp',
    commercial: 'NB_commercial',
} as const;
